import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div style={{ padding: 24, fontFamily: "Montserrat, sans-serif" }}>
      <h2>Página no encontrada</h2>
      <p>La ruta que intentaste abrir no existe.</p>
      <p>
        <Link to="/">Volver al inicio</Link>
      </p>
    </div>
  );
};

export default NotFound;

